export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const  setAllUser  = (state, items) => {
  state.users = items
}


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/users/mutations.js